import { BrowserRouter, useNavigate } from "react-router-dom";
import "../src/theme/styles/App.css";
import { ThemeProvider } from "@emotion/react";
import primaryTheme from "./theme/theme";
import AppRoutes from "./routes/AppRoutes";
import SnackbarPopup from "./shared/ReusableComponents/Snackbar";

function App() {
  return (
    <ThemeProvider theme={primaryTheme}>
      <BrowserRouter>
        <SnackbarPopup />
        <AppRoutes />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
